import React, { useState } from "react";
import { Button, Grid, Typography, Modal, ThemeProvider } from "@mui/material";
import { styled } from "@mui/material/styles";
// import { makeStyles } from "@mui/material/styles";

import CheckIcon from "@mui/icons-material/Check";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { basicTheme } from "../../themes/customTheme";
import { useDispatch } from "react-redux";
import { removeDuplicates } from "../../utils/index";
import BackDropLoader from "../reusableComponents/BackDropLoader";
import SnackBars from "../reusableComponents/SnackBar";
import BasicTextfield from "../reusableComponents/BasicTextfield";
import BasicDropDown from "../reusableComponents/BasicDropDown";
import AutoCompleteDropdown from "../reusableComponents/AutoCompleteDropDown";
import AutoCompleteMultiDropdown from "../projects/AutoCompleteMultiDropdown";
import { getProjectData } from "../../features/projects/projectsAPIs";
import {
  postPartnerData,
  getGroupData,
} from "../../features/partner/partnerAPIs";
import InputAdornment from "@mui/material/InputAdornment";
import { Password } from "@mui/icons-material";

const subGridStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  px: 6,
  boxShadow: 24,
  borderRadius: "1.5rem",
  width: "65%",
  maxHeight: "80%",
  overflowY: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
  scrollbarWidth: "thin",
  scrollbarColor: "transparent transparent",
};


const ButtonStyle = styled(Button)({
  backgroundColor: "#1e88e5",
  color: "white",
  textTransform: "none",
  borderRadius: "1rem",
  fontSize: "16px",
  fontWeight: "600",
  minWidth: "140px",
  maxWidth: "150px",
  height: "54px",
});

const CancelButtonStyle = styled(Button)({
  backgroundColor: "white",
  color: "#2D6A4F",
  textTransform: "none",
  borderRadius: "1rem",
  fontSize: "16px",
  fontWeight: "600",
  minWidth: "140px",
  maxWidth: "150px",
  height: "54px",
});

export default function AddPartnerModal({
  openAddModal,
  handleClose,
  setPartnerSnackBarMessage = () => {},
  setPartnerSnackBarType = () => {},
  setReload = () => {},
  setOpenSuccessBox = () => {},
  setSuccessMessage = () => {},
  setOpenSuccessBoxType = () => {},
}) {
  // const classes = useStyles();
  const dispatch = useDispatch();
  const [partnerName, setPartnerName] = useState("");
  const [spocName, setSpocName] = useState("");
  const [spocPassword, setspocPassword] = useState("");
  const [spocNumber, setSpocNumber] = useState("");
  const [spocEmail, setSpocEmail] = useState("");
  const [projects, setProjects] = useState([]);
  const [partnerStatus, setPartnerStatus] = useState("");
  const [addPartnerSnackBar, setAddPartnerSnackBar] = useState(false);
  const [addPartnerSnackBarMessage, setAddPartnerSnackBarMessage] =
    useState("");
  const [groupDataResponse, setGroupDataResponse] = useState([]);
  const [groupNamesData, setGroupNamesData] = useState([]);
  const [userGroup, setUserGroup] = useState([]);
  const handleChangeUserGroup = (value) => {
    setUserGroup(value);
    setErrors({ ...errors, userGroup: "" });
  };

  const basicError = {
    partnerName: "",
    spocEmail: "",
    spocNumber: "",
    spocPassword: "",
    spocName: "",
    partnerStatus: "",
    projects: "",
    userGroup: "",
  };
  const [snackBarType, setSnackBarType] = useState("success");
  const [errors, setErrors] = useState(basicError);

  const partnerStatusList = ["Active", "Inactive"];
  const protocolList = [
    { id: 1, name: "Weekly Monitoring Protocol" },
    { id: 2, name: "CICR" },
  ];
  const [loading, setLoading] = useState(false);

  const [addAnotherLocationDropDown, setAddAnotherLocationDropDown] =
    useState(1);
  const [location, setLocation] = useState([
    {
      state: null,
      district: null,
      taluka: null,
      villages: [],
    },
  ]);

  const getGroupList = async () => {
    setLoading(true);
    try {
      const response = await getGroupData();
      setGroupDataResponse(response.data);
      const loggedInUser = JSON.parse(window.localStorage.getItem("loggedInUser"));
      const isAdmin = loggedInUser?.role?.includes("Admin");

      let groupNamesList;
      if (isAdmin) {
        groupNamesList = response.data.map((item) => ({
          id: item.id,
          name: item.name,
        }));
      } else {
        groupNamesList = response.data
          .filter((item) => item.name === "Data-Collector")
          .map((item) => ({
            id: item.id,
            name: item.name,
          }));
      }
      setGroupNamesData(groupNamesList);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setSnackBarType("error");
      setAddPartnerSnackBar(true);
      setAddPartnerSnackBarMessage("Error while getting group list");
    }
  };

  const validateFormData = () => {
    let partnerNameError = "";
    let partnerEmailError = "";
    let userGroupError = "";

    if (partnerName.trim() === "") {
      partnerNameError = "Partner Name can't be empty";
    }
    if (spocEmail === "") {
      partnerEmailError = "Email can't be empty";
    }

    if (userGroup.length === 0) {
      userGroupError = "Please select at least one group";
    }
    setErrors({
      ...errors,
      partnerName: partnerNameError,
      spocEmail: partnerEmailError,
      userGroup: userGroupError,
    });
  };

  const handleChangePartnerName = (value) => {
    value = value.trim(); // Trim leading and trailing spaces
    const USERNAME_REGEX = /^[a-zA-Z0-9@/./+/-/_]{1,150}$/;

    if (value === "") {
      setErrors({ ...errors, partnerName: "Username can't be empty" });
    } else if (!USERNAME_REGEX.test(value)) {
      setErrors({
        ...errors,
        partnerName: "Username can only contain letters, digits, and @/./+/-/_",
      });
    } else {
      setErrors({ ...errors, partnerName: "" });
    }
    setPartnerName(value);
  };

  const handleChangespocPassword = (value) => {
    value = value.replace(/^\s+/g, "");

    if (value.trim() === "") {
      setErrors({ ...errors, spocPassword: "Field can't be empty" });
      value = "";
    } else {
      setErrors({ ...errors, spocPassword: "" });
    }
    setspocPassword(value);
  };
  

  const handleChangeSpocEmail = (value) => {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (value.match(mailformat)) {
      setErrors({ ...errors, spocEmail: "" });
    } else if (value === "") {
      setErrors({ ...errors, spocEmail: "Email can't be empty" });
    } else {
      setErrors({ ...errors, spocEmail: "Invalid Email " });
    }
    setSpocEmail(value);
  };


  const handleChangeSpocNumber = (phoneNumber) => {
    phoneNumber = phoneNumber.trim();
    const reg = /^[1-9][0-9]*$/;
    if (phoneNumber === "") {
      setErrors({ ...errors, spocNumber: "Phone number can't be empty " });
    } else if (!reg.test(phoneNumber)) {
      setErrors({
        ...errors,
        spocNumber: "Phone number should not start with 0 ",
      });
    } else if (phoneNumber.length !== 10) {
      setErrors({ ...errors, spocNumber: "Phone number should be 10 digits" });
    } else {
      setErrors({ ...errors, spocNumber: "" });
    }
    setSpocNumber(phoneNumber);
  };

  const handleCloseByClearIcon = () => {
    setErrors(basicError);
    setPartnerName("");
    setSpocName("");
    setSpocNumber("");
    setSpocEmail("");
    //setProjects("");
    setspocPassword("");
    setPartnerStatus("");
    setAddPartnerSnackBar(false);
    setSnackBarType("success");
    setAddPartnerSnackBarMessage("");
    setPartnerSnackBarMessage("");
    setLocation([
      {
        state: null,
        district: null,
        taluka: null,
        villages: [],
      },
    ]);
    handleClose();
  };

  const setLocationForApi = () => {
    var locations = {
      state_ids: [],
      district_ids: [],
      taluka_ids: [],
      village_ids: [],
    };
    if (location[0].villages.length > 0) {
      location.forEach((item) => {
        locations["state_ids"].push(item.state.id);
        locations["district_ids"].push(item.district.id);
        locations["taluka_ids"].push(item.taluka.id);
        item.villages.forEach((villageObj) => {
          if (villageObj.id !== "all")
            locations["village_ids"].push(villageObj.id);
        });
      });
      locations["state_ids"] = removeDuplicates(locations["state_ids"]);
      locations["district_ids"] = removeDuplicates(locations["district_ids"]);
      locations["taluka_ids"] = removeDuplicates(locations["taluka_ids"]);
      locations["village_ids"] = removeDuplicates(locations["village_ids"]);
    }

    return locations;
  };

  const handleSaveData = async () => {
    // var locations = setLocationForApi();
    if (
      errors.userGroup === "" &&
      errors.partnerName === "" &&
      errors.spocEmail === "" &&
      partnerName !== "" &&
      spocEmail !== "" &&
      userGroup.length > 0
    ) {
      setAddPartnerSnackBar(false);
      setSnackBarType("success");
      setAddPartnerSnackBarMessage("");
      var isActive = partnerStatus === "Active" ? true : false;
      setLoading(true);
      const groupIdArray = userGroup.map((user) => user.id);
      const data = {
        email: spocEmail,
        username: partnerName,
        password:spocPassword,
        group_names: groupIdArray,
      };
      try {
        const response = await postPartnerData(data);
        // setPartnerSnackBarType("success");
        // setPartnerSnackBarMessage(response.data["message"]);
        setReload(true);
        setLoading(false);
        handleClose();
        setSuccessMessage(response.data["msg"]);
        setOpenSuccessBoxType("success");
        setOpenSuccessBox(true);
      } catch (error) {
        setOpenSuccessBox(true);
        setSuccessMessage(error.response.data);
        setOpenSuccessBoxType("error");
        setLoading(false);
      }
    } else {
      validateFormData();
      setOpenSuccessBox(true);
      setSuccessMessage("Please fill all the required fields");
      setOpenSuccessBoxType("error");
    }
  };

  const handleChangeLocation = (newValue, index, type, menuList) => {
    var newLocation = [...location];
    if (type === "state") {
      newLocation[index].state = newValue;
      newLocation[index].district = null;
      newLocation[index].taluka = null;
      newLocation[index].villages = [];
      setLocation(newLocation);
    } else if (type === "district") {
      newLocation[index].district = newValue;
      setLocation(newLocation);
      newLocation[index].taluka = null;
      newLocation[index].villages = [];
    } else if (type === "taluka") {
      newLocation[index].taluka = newValue;
      setLocation(newLocation);
      newLocation[index].villages = [];
    } else if (type === "village") {
      var oldSelected = newLocation[index].villages;
      var containsAllInOld = oldSelected.some((obj) => obj.name === "All");
      var containsAll = newValue.some((obj) => obj.name === "All");

      if (containsAll) {
        newLocation[index].villages = menuList;
        console.log("manulisy", menuList);
      } else if (!containsAll && containsAllInOld) {
        newLocation[index].villages = [];
      } else {
        newLocation[index].villages = newValue;
      }
      setLocation(newLocation);
    }
  };

  return (
    <Modal open={openAddModal}>
      <Grid container sx={subGridStyle} spacing={1}>
        <ThemeProvider theme={basicTheme}>
          <Grid
            container
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 1,
              backgroundColor: "white",
              marginTop: 2,
              paddingTop: 2,
              // paddingTop: 4,
            }}
          >
            <Grid item xs={11}>
              <Typography
                variant="h4"
                sx={{ color: "#444444", fontWeight: "500" }}
              >
                Add User
              </Typography>
            </Grid>
            <Grid
              item
              xs={1}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <CloseRoundedIcon
                // className={classes.closeBtnStyle}
                onClick={handleCloseByClearIcon}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              width: "90%",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ marginBottom: 1 }}>Username</Typography>
                <BasicTextfield
                  label="Enter Username"
                  is_phone={false}
                  handleChange={handleChangePartnerName}
                  is_disabled={false}
                  index={1}
                  error={errors.partnerName !== ""}
                  helperText={errors.partnerName}
                  required={true}
                  value={partnerName}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  sx={{
                    marginBottom: 1,
                  }}
                >
                  Groups
                </Typography>
                <AutoCompleteMultiDropdown
                  width="auto"
                  menuList={groupNamesData}
                  selectedOptions={userGroup}
                  setSelectedOptions={handleChangeUserGroup}
                  label="Select Group(s)"
                  required={true}
                  onOpen={getGroupList}
                  loading={loading}
                  error={errors.userGroup !== ""}
                  errorText={errors.userGroup}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography sx={{ marginBottom: 1 }}>Email ID</Typography>
                <BasicTextfield
                  label="Enter Email Id"
                  is_phone={false}
                  handleChange={handleChangeSpocEmail}
                  is_disabled={false}
                  index={5}
                  error={errors.spocEmail !== ""}
                  helperText={errors.spocEmail}
                  required={true}
                  value={spocEmail}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ marginBottom: 1 }}>Password</Typography>
                <BasicTextfield
                  label="Enter Password"
                  is_password={true}
                  is_phone={false}
                  handleChange={handleChangespocPassword}
                  is_disabled={false}
                  index={3}
                  error={errors.spocPassword !== ""}
                  helperText={errors.spocPassword}
                  required={true}
                  value={spocPassword}
                />

              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            item
            sm={12}
            sx={{
              position: "sticky",
              bottom: 0,
              zIndex: 1,
              backgroundColor: "white",
              justifyContent: "center",
            }}
          >
            <Grid item sx={{ margin: "30px" }}>
              <ButtonStyle
                variant="contained"
                name="cancel"
                onClick={handleClose}
              >
                Cancel
              </ButtonStyle>
            </Grid>
            <Grid item sx={{ margin: "30px" }}>
              <ButtonStyle
                variant="contained"
                name="add"
                startIcon={<CheckIcon size="large" />}
                onClick={handleSaveData}
              >
                Save
              </ButtonStyle>
              {addPartnerSnackBar && (
                <SnackBars
                  open={addPartnerSnackBar}
                  handleClose={() => setAddPartnerSnackBar(false)}
                  severity={snackBarType}
                  message={addPartnerSnackBarMessage}
                  autoHideDuration={6000}
                  vertical="bottom"
                  horizontal="center"
                  position="absolute"
                />
              )}
            </Grid>
          </Grid>
          <BackDropLoader loading={loading} />
        </ThemeProvider>
      </Grid>
    </Modal>
  );
}
